'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PostHogProviderImpl } from 'posthog-js/react'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProviderImpl client={posthog}>{children}</PostHogProviderImpl>
}
